import { useFaqWidget } from "../../../providers/context";
import { DownloadButton } from "~/components/Buttons/DownloadButton";

export function FaqDownloadButton() {

	const { 
		setFaqDownloadButton,
		isDownloading,
		downloadFaq
	} = useFaqWidget();

	return (
		<DownloadButton
			ref={setFaqDownloadButton}
			loading={isDownloading()}
			disabled={isDownloading()}
			onClick={downloadFaq}
		/>
	);
}